import {
  actionCreator,
  checkHttpStatus,
  createRequestActionTypes,
  jsonApiHeader,  
  API_URL
} from '../../../actions/utilAction';

export {
  actionCreator,
  jsonApiHeader,
  checkHttpStatus,
  API_URL,
};

export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_STAFF_BYLOCATION = `${API_URL}/api/PatientAppointments/GetStaffByLocation`;
export const GET_PATIENT = `${API_URL}/api/PatientAppointments/GetStaffAndPatientByLocation`;
export const GET_HAS_URLACCESS = `${API_URL}/api/RolePermission/HasUrlAccess`;
export const GET_PATIENTLIST = `${API_URL}/api/PatientAppointments/GetPatientByLocationWithExcludeFullyPaid`;
export const GET_PATIENTLIST_WITHPERMISSION = `${API_URL}/api/PatientAppointments/GetPatientByLocationWithPermission`;
export const GET_REPORTSBYTYPECATEGORY = `${API_URL}/User/GetReportsByTypeCategory`;
export const GET_PATIENT_BY_LACARE = `${API_URL}/api/PatientAppointments/GetLACarePatientByLocation`;
export const GET_EXCEL_PAYROLL_APPOINTMENT_HISTORY = `${API_URL}/api/PatientAppointments/GetExcelPayrollAppointmentHistory`;
export const GET_PAYROLL_APPOINTMENT_HISTORY = `${API_URL}/api/PatientAppointments/GetPayrollAppointmentHistory`;
export const SET_MARK_APPOINTMENTS_AS_PAID = `${API_URL}/api/PatientAppointments/MarkAppointmentsAsPaid`;
export const SET_UNDO_MARK_APPOINTMENT_AS_PAID = `${API_URL}/api/PatientAppointments/UndoMarkedAsPaidAppointment`;

export const reportActionTypes = {  
  get_masterdata: createRequestActionTypes('GET_MASTERSDATA'),
  get_Staff_ByLocation: createRequestActionTypes('GET_STAFF_BYLOCATION'),
  get_patient: createRequestActionTypes('GET_PATIENT'),
  get_hasurlaccess: createRequestActionTypes('GET_HAS_URLACCESS'),
  get_reportsbytypecategory: createRequestActionTypes('GET_REPORTSBYTYPECATEGORY'),
  get_excel_payroll_history: createRequestActionTypes('GET_EXCEL_PAYROLL_HISTORY'),
  get_payroll_history: createRequestActionTypes('GET_PAYROLL_HISTORY'),
  mark_appointments_as_paid: createRequestActionTypes('SET_MARK_APPOINTMENTS_AS_PAID'),
  undo_mark_appointments_as_paid: createRequestActionTypes('SET_UNDO_MARK_APPOINTMENT_AS_PAID'),
};




// WEBPACK FOOTER //
// ./src/modules/Reports/constants/ApiContants.js